/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MeseAnnoLight interface.
 */
export function instanceOfMeseAnnoLight(value) {
    return true;
}
export function MeseAnnoLightFromJSON(json) {
    return MeseAnnoLightFromJSONTyped(json, false);
}
export function MeseAnnoLightFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mese': json['mese'] == null ? undefined : json['mese'],
        'anno': json['anno'] == null ? undefined : json['anno'],
        'consolidato': json['consolidato'] == null ? undefined : json['consolidato'],
    };
}
export function MeseAnnoLightToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'mese': value['mese'],
        'anno': value['anno'],
        'consolidato': value['consolidato'],
    };
}
